import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["distributorSelect", "personaSelect"]

  connect() {
    this.toggleDistributorField()
  }

  personaChanged() {
    this.toggleDistributorField()
  }

  toggleDistributorField() {
    const persona = this.personaSelectTarget.value
    // Enable for unmanaged (Huntress-supported)
    const shouldEnable = persona === "unmanaged"

    if (shouldEnable) {
      this.distributorSelectTarget.removeAttribute("disabled")
    } else {
      this.distributorSelectTarget.setAttribute("disabled", "disabled")
      // Clear selection when disabled
      $(this.distributorSelectTarget).val(null).trigger("change")
    }
  }
}
